import { Component, Input, OnInit } from '@angular/core';
import { IFundraiser } from '../../fundraiser/models/fundraiser.model';
import { EventsService, UtilService, VariablesService } from '../../shared/services';

@Component({
  selector: 'app-hospital-doctor-contact',
  templateUrl: './hospital-doctor-contact.component.html',
  styleUrls: ['./hospital-doctor-contact.component.scss']
})
export class HospitalDoctorContactComponent implements OnInit {

  @Input() fundraiser: IFundraiser;
  isMobile;

  constructor(
    private eventsService: EventsService,
    public vars: VariablesService,
    public util: UtilService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.util?.isMobile();
  }

  sendEvent(to: 'k' | 'h') {
    const payload = {
      eventName: to === 'k' ? 'Krep_contacted' : 'hospital_contacted',
      page_name: this.vars.pageName,
      event_type_id: this.fundraiser.id
    };
    this.eventsService.sendSystemEvent(payload).subscribe(_ => _);
  }
}
